/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { RuntimeMetricsAutoTreatContext } from '../contexts/RuntimeMetricsAutoTreatContext';
import { MachinesContext } from '../../../modules/machinesAdminManagement/contexts/MachinesContext';
import RuntimeMetricsAutoTreatList from './RuntimeMetricsAutoTreatList';
import MachineStatusBanner from '../../../modules/shared/machineManagement/MachineStatusBanner';

const RuntimeMetricsAutoTreatPage: React.FunctionComponent = () => {
  const [initialDataLoaded, setDataLoaded] = React.useState(false);

  const { fetchRuntimeMetricsAutoTreat, detailPage, activeMachine } = React.useContext(
    RuntimeMetricsAutoTreatContext,
  );
  const { fetchAutoTreatMachines } = React.useContext(MachinesContext);

  React.useEffect(() => {
    const getMachines = async () => {
      if (!initialDataLoaded) {
        setDataLoaded(true);
        fetchAutoTreatMachines();
      }
    };

    getMachines();
  }, [initialDataLoaded, setDataLoaded, fetchRuntimeMetricsAutoTreat]);

  const autoTreatRuntimeMetricPage = () => {
    if (detailPage) {
      return 'updatePage';
    }

    return 'listPage';
  };

  return (
    <>
      <MachineStatusBanner activeMachine={activeMachine} />
      {
        {
          listPage: <RuntimeMetricsAutoTreatList />,
        }[autoTreatRuntimeMetricPage()]
      }
    </>
  );
};

export default RuntimeMetricsAutoTreatPage;
